import BaseController from "./BaseController";
import { AuthService } from "../service/Auth.service";
import JSONModel from "sap/ui/model/json/JSONModel";
import Input, { Input$ChangeEvent } from "sap/ui/webc/main/Input";
import PropertyBinding from "sap/ui/model/PropertyBinding";
import String1 from "sap/ui/model/type/String";
import MessageToast from "sap/m/MessageToast";
import MessageBox from "sap/m/MessageBox";
import { EnvironmentService } from "../service/Environment.service";
import { ErrorHandler } from "../service/ErrorHandler.service";
import { Input$LiveChangeEvent } from "sap/m/Input";

/**
 * @namespace com.unitrade.crm.controller
 */
export default class Login extends BaseController {
  _authService: AuthService;

  private _oModel: JSONModel;

  async onInit(): Promise<void> {
    this._authService = new AuthService();
    this._oModel = new JSONModel({
      haus: 1,
      username: "",
      password: "",
      hausLoading: true,
      submitting: false,
    });
    this.setModel(this._oModel);
  }

  public override getisNavBackEnabled(): Promise<boolean> {
    return Promise.resolve(false);
  }

  public async submit() {
    const aInputs = [this.byId("login_haus_input") as Input, this.byId("login_username_input") as Input, this.byId("login_password_input") as Input];
    let bValidationError = false;

    aInputs.forEach((oInput: Input) => {
      bValidationError = this._validateInput(oInput) || bValidationError;
    }, this);

    if (bValidationError) {
      MessageToast.show(await this.getTranslatedString("invalid_login_data"));
    } else {
      const oModel = this.getModel() as JSONModel;
      try {
        const haus: number = parseInt(oModel.getProperty("/haus"));
        const username: string = oModel.getProperty("/username").toUpperCase(); // U7 Logins are always uppercase
        const password: string = oModel.getProperty("/password");
        oModel.setProperty("/submitting", true);

        const bResult = await this._authService.authenticate(haus, username, password);
        if (bResult === "OK") {
          oModel.setProperty("/password", "");
          const router = this.getOwnerComponent().getRouter();
          const currentHash = router.getHashChanger().getHash();
          const routeInfo = router.getRouteInfoByHash(currentHash);
          if (routeInfo.name === "loginWithRedirect") {
            const routeInfoArgs = JSON.parse(routeInfo.arguments.redirect as string);
            const routeName = routeInfoArgs.name;
            delete routeInfoArgs.name;
            router.navTo(routeName, routeInfoArgs);
          } else {
            router.navTo("home");
          }
        } else {
          MessageBox.error(bResult);
        }
      } catch (ex: any) {
        ErrorHandler.handleError(ex, { message: "Fehler beim Login", ignorable: true, onRetry: this.submit });
      } finally {
        oModel.setProperty("/submitting", false);
      }
    }
  }

  public onInputChange(oEvent: Input$ChangeEvent) {
    const oInput = oEvent.getSource();
    this._validateInput(oInput);
  }

  private _validateInput(oInput: Input) {
    let sValueState = "None";
    let bValidationError = false;
    const oBinding = oInput.getBinding("value") as PropertyBinding;

    try {
      const type = oBinding.getType() as String1;
      type.validateValue(oInput.getValue());
    } catch (oException) {
      sValueState = "Error";
      bValidationError = true;
    }

    oInput.setValueState(sValueState as "None" | "Error");

    return bValidationError;
  }

  public onlyNumbers = (oEvent: Input$LiveChangeEvent) => {
    var _oInput = oEvent.getSource();
    var val = _oInput.getValue();
    val = val.replace(/[^\d]/g, "");
    _oInput.setValue(val);
  };
}
